import { TaskInternalType } from '@gcv/shared';

import type { TaskDetails } from '../../tasks/tasks.model';
import { hasSubtasks, isGroupedTask } from '../../tasks/tasks.model';

/** Whether the drawer renders the grouped subtask table instead of single-task fields. */
export const isGroupedTaskView = (task: TaskDetails | null): boolean => {
  if (!task) {
    return false;
  }

  const isGrouped = isGroupedTask(task);

  // Monitoring reviews always show the grouped view, even with a single subtask
  if (task.internalType === TaskInternalType.MONITORING_REVIEWS && isGrouped) {
    return true;
  }

  return Boolean(isGrouped) && hasSubtasks(task);
};
